import { Button, Space } from "antd";
import { useState, useEffect } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { createFromIconfontCN, TeamOutlined } from "@ant-design/icons";
import SignIn from "./SignIn";

const IconFont = createFromIconfontCN({
  scriptUrl: "//at.alicdn.com/t/c/font_4531892_mvguvbkne89.js",
});

export default function HomeHeader() {
  const [ismobile, setIsMobile] = useState(0);
  const navigate = useNavigate();

  const [showHeader, setShowHeader] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const scrollingUp = currentScrollY < lastScrollY;
      const atTop = currentScrollY < 100;

      if (atTop) {
        setShowHeader(true);
      } else {
        setShowHeader(scrollingUp);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollY]);

  useEffect(() => {
    const handleResize = () =>
      setIsMobile(window.innerHeight > window.innerWidth ? 1 : 0);
    window.addEventListener("resize", handleResize);
    // Call handleResize right away so that ismobile is set correctly initially
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <HeaderWrapper show={showHeader} transparentBg={lastScrollY < 100}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: "6vh",
          width: "100%",
        }}
      >
        <img
          src={ismobile ? "/titleLogoLight.png" : "/RfSonsLogoLight.png"}
          alt=""
          style={{
            height: "60%",
            paddingLeft: "8%",
            cursor: "pointer",
          }}
          onClick={() => {
            window.location = "/";
          }}
        />
        <Space
          direction="horizontal"
          style={{
            alignItems: "center",
            width: "100%",
            justifyContent: "center",
            height: "100%",
          }}
        >
          <StyledButton
            ismobile={ismobile}
            type="text"
            icon={ismobile ? <IconFont type="icon-portfolio" /> : ""}
            onClick={(e) => {
              navigate("/home_project");
              const projectElement = document.getElementById("project");
              if (projectElement) {
                projectElement.scrollIntoView({ behavior: "smooth" });
              }
            }}
          >
            {ismobile ? " " : "Projects"}
          </StyledButton>
          <StyledButton
            ismobile={ismobile}
            type="text"
            icon={ismobile ? <IconFont type="icon-jianmo" /> : ""}
            onClick={(e) => {
              navigate("/#services");
              const servicesElement = document.getElementById("services");
              if (servicesElement) {
                servicesElement.scrollIntoView({ behavior: "smooth" });
              }
            }}
          >
            {ismobile ? " " : "Services"}
          </StyledButton>

          <StyledButton
            ismobile={ismobile}
            type="text"
            icon={ismobile ? <TeamOutlined /> : ""}
            onClick={(e) => {
              navigate("/home_member");
              const servicesElement = document.getElementById("Members");
              if (servicesElement) {
                servicesElement.scrollIntoView({ behavior: "smooth" });
              }
            }}
          >
            {ismobile ? " " : "Members"}
          </StyledButton>
          <StyledButton
            ismobile={ismobile}
            type="text"
            icon={ismobile ? <IconFont type="icon-about-us" /> : ""}
            onClick={(e) => {
              navigate("/#about");
              const servicesElement = document.getElementById("about");
              if (servicesElement) {
                servicesElement.scrollIntoView({ behavior: "smooth" });
              }
            }}
          >
            {ismobile ? " " : "About Us"}
          </StyledButton>
        </Space>

        <SignIn
          ismobile={ismobile}
          style={{
            height: "100%",
            width: "8%",
            marginRight: "7%",
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
          }}
        />
      </div>
    </HeaderWrapper>
  );
}

const StyledButton = styled(Button)`
  font-size: calc(
    100vh * ${(props) => (props.ismobile ? 20 : 18)} /
      ${(props) => (props.ismobile ? 720 : 1080)}
  );
  margin-right: 10%;
  background-color: transparent;
  color: white;
  height: 100%;
  &&:hover {
    color: #18dcff !important;
  }
`;
const HeaderWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  isolation: isolate;
  transition: transform 0.3s ease;
  transform: translateY(${(props) => (props.show ? "0" : "-100%")});
  background: ${(props) =>
    props.transparentBg ? "transparent" : "rgba(0, 5, 20, 0.8)"};
  backdrop-filter: ${(props) => (props.transparentBg ? "none" : "blur(10px)")};
`;
